import {PopupState} from './popup.reducer.types';

const initialState: PopupState = [];

export const popupReducer = (previousState = initialState, action): PopupState => {
	let newState = previousState;

	const showPopup = action.showPopup || action.payload?.showPopup || action.meta?.showPopup;
	if (showPopup) {
		newState = [...newState.filter(popup => popup !== showPopup), showPopup];
	}

	const hidePopups = action.hidePopups || action.payload?.hidePopups || action.meta?.hidePopups;
	if (hidePopups) {
		newState = newState.filter(popup => !hidePopups.includes(popup));
	}

	return newState;
};
